import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

const QuestionAnswer = ({ image, content, caption, overline }) => {
  return (
    <>
      <div className='ml40 grid p40 m-m0'>
        <div className='mt10 p40 m-p0'>
          <div className='overflow w-50 max-300 m-mwa m-100'>
            <GatsbyImage image={image?.gatsbyImageData} alt='' className='cover' />
          </div>
          {caption && (
            <div className='mt10'>
              <p className='small m0'>{overline || "Pictured"}</p>
              <span className='small op-50'>{caption}</span>
            </div>
          )}
        </div>
        <article className='p40 m-p0'>
          {content?.map((block, index) => (
            <React.Fragment key={index}>
              <p className='flex m0 mb20'>
                <div className={"h5 m0 m-pr20 white-space block-content"} dangerouslySetInnerHTML={{ __html: block?.answer }} />
              </p>
            </React.Fragment>
          ))}
        </article>
      </div>
    </>
  )
}

export default QuestionAnswer
